import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export default function ChatIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M8 17h.75v-.76H8V17Zm0 3h-.75a.75.75 0 0 0 1.2.6L8 20Zm4-3v-.76h-.25l-.2.15.45.6ZM9 9.24h-.75v1.5H9v-1.5Zm6 1.5h.75v-1.5H15v1.5Zm-6 1.5h-.75v1.5H9v-1.5Zm4 1.5h.75v-1.5H13v1.5Zm-5.75 3.24v3h1.5v-3h-1.5Zm1.2 3.6 4-3-.9-1.2-4 3 .9 1.2ZM12 17.74h6v-1.5h-6v1.5Zm6 0c.97 0 1.75-.78 1.75-1.75h-1.5c0 .14-.11.25-.25.25v1.5ZM19.75 16V7h-1.5v9h1.5Zm0-9c0-.96-.78-1.74-1.75-1.74v1.5c.14 0 .25.11.25.25h1.5ZM18 5.26H6v1.5h12v-1.5Zm-12 0c-.97 0-1.75.78-1.75 1.75h1.5c0-.14.11-.25.25-.25v-1.5ZM4.25 7v9h1.5V7h-1.5Zm0 9c0 .96.78 1.74 1.75 1.74v-1.5a.25.25 0 0 1-.25-.25h-1.5ZM6 17.73h2v-1.5H6v1.5Zm3-7h6v-1.5H9v1.5Zm0 3h4v-1.5H9v1.5Z" />
        </SvgIcon>
    )
}
